var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"filing"},[_c('div',{staticClass:"container"},[_c('el-link',{attrs:{"type":"primary"},on:{"click":_vm.open}},[_vm._v("免责声明 ")]),_vm._v(" "),_c('el-link',{staticClass:"number",staticStyle:{"margin-left":"7px"},attrs:{"underline":false,"type":"primary"}},[_vm._v("河北国超信息科技有限公司 冀ICP备05017071号")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c2f16a70","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Filing.vue
// module id = null
// module chunks = 